import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isInitialized: false,
    isAppLoading: false,
    currentLocale: process.env.VUE_APP_DEFAULT_LOCALE,
    currentLocaleCode: process.env.VUE_APP_DEFAULT_LOCALE_CODE,
    googleVerifyKey: null,
    maintenanceModeActive: false,
    maintenanceModeContent: null,
    maintenanceModeOnlyProduction: false,
  },
  modules,
  actions,
  getters,
  mutations,
});
